import { checkHttpStatus, parseJSON, expiredToken } from '@utils/response'
import { Token, UserCode, EmployeeId, Company, AccessType, UserAssociation, EmployeeCode } from '@utils/users'
import { errorResponse, okResponse} from '@utils/response';
import { encryption } from '@utils/encryption';

export function getHRRequestList(status, requestTypes) {
    const body = JSON.stringify({
        userCodeCrypt: encryption(UserCode()),
        employeeIdCrypt: encryption(EmployeeId()),
        companyCrypt: encryption(Company()),
        statuses: status,
        requestTypes: requestTypes,
        token: Token()
    });

    return fetch('HRRequest/GetAllHRRequestList', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: body
    })
    .then(checkHttpStatus)
    .then(expiredToken)
    .then(parseJSON)
    .then(response => {
        try {
            return new okResponse(response);
        } catch (e) {
            errorResponse(response);
        }
    })
    .catch(error => {
        errorResponse(error);
    })
}

export function getHRRequestDocumentsList(hrRequestId) {
    const body = JSON.stringify({
        userCodeCrypt: encryption(UserCode()),
        employeeIdCrypt: encryption(EmployeeId()),
        hrRequestIdCrypt: encryption(hrRequestId),
        companyCrypt: encryption(Company()),
        token: Token()
    });

    return fetch('HRRequest/GetHRRequestDocumentList', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: body
    })
    .then(checkHttpStatus)
    .then(expiredToken)
    .then(parseJSON)
    .then(response => {
        try {
            return new okResponse(response);
        } catch (e) {
            errorResponse(response);
        }
    })
    .catch(error => {
        errorResponse(error);
    })
}

export function saveHRRequest(hrRequest, files) {

    const formData = new FormData();
    
    /* REQUEST INFO */
    formData.append('userCodeCrypt', encryption(UserCode()));
    formData.append('employeeIdCrypt', encryption(EmployeeId()));
    formData.append('companyCrypt', encryption(Company()));
    formData.append('token', Token());
    formData.append('requestIdCrypt', encryption(hrRequest.hrRequest.hrRequestId) || 0 );
    formData.append('hrRequestTypeId', hrRequest.hrRequestTypeId || 0 );
    formData.append('status', hrRequest.hrRequest.status || 0 );
    formData.append('description', hrRequest.description || '' );
    formData.append('createDate', hrRequest.createDate || '' );
    formData.append('origin', hrRequest.hrRequest.origin || 'E');
    formData.append('visibleByEmployee', hrRequest.hrRequest.visibleByEmployee || 'O');
    formData.append('visibleBySupervisor', hrRequest.hrRequest.VisibleBySupervisor || 'O');
    formData.append('accessType', AccessType() );
    formData.append('employeeCodeCrypt', encryption(EmployeeCode()));
    formData.append('assignedCode', '' );
    formData.append('assignedId', 0 );
    formData.append('hrRequestCreationUserAssociationId', UserAssociation() );

    /* DOCUMENT LIST */
    files.forEach((file, index) => {
        formData.append( `documentList[${index}].HrRequestDocumentIdCrypt`, encryption(file.hrRequestDocumentId) || 0 );
        formData.append( `documentList[${index}].documentName`, file.documentName || ''  );
        formData.append( `documentList[${index}].comment`, file.comment || '' );
        formData.append( `documentList[${index}].gdDocumentIDEncrypt`, file.gdDocumentIDEncrypt || '' );
        formData.append( `documentList[${index}].documentDataBase64`, file.document || '' );
    });

    return fetch('HRRequest/SaveHRRequest', {
        method: 'post',
        credentials: 'include',

        // IMPORTANT:
        // DO NOT SET CONTENT-TYPE

        headers: {
            'Accept': 'application/json'
        },

        body: formData
    })
    .then(checkHttpStatus)
    .then(expiredToken)
    .then(parseJSON)
    .then(response => {

        try {
            return new okResponse(response);
        }
        catch (e) {
            errorResponse(response);
        }
    })
    .catch(error => {
        errorResponse(error);
    });
}

export function deleteHRRequest(hrRequestId) {
    const body = JSON.stringify({
        userCodeCrypt: encryption(UserCode()),
        hrRequestIdCrypt: encryption(hrRequestId),
        token: Token()
    });

    return fetch('HRRequest/DeleteHRRequest', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: body
    })
    .then(checkHttpStatus)
    .then(expiredToken)
    .then(parseJSON)
    .then(response => {
        try {
            return new okResponse(response);
        } catch (e) {
            errorResponse(response);
        }
    })
    .catch(error => {
        errorResponse(error);
    })
}

export function getAllCombos() {
    const body = JSON.stringify({
        userCodeCrypt: encryption(UserCode()),
        companyCrypt: encryption(Company()),
        token: Token()
    });
    return fetch('HRRequest/GetAllCombos', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: body
    })
    .then(checkHttpStatus)
    .then(expiredToken)
    .then(parseJSON)
    .then(response => {
        try {
            return new okResponse(response);
        } catch (e) {
            errorResponse(response);
        }
    })
    .catch(error => {
        errorResponse(error);
    })
}
